export default __webpack_public_path__ + "static/Mindful-logo-Transparentbackground-9eeec2ca3e7a64c6d46399a9efb850ef.png";